<template>
  <v-card
    outlined
    class="address-item-card pa-4 fill-height d-flex flex-column"
    :class="{ 'default-address': storage._id === defaultAddress._id }"
  >
    <div class="d-flex justify-space-between align-start mb-3">
      <div class="d-flex align-start" style="width: calc(100% - 70px);">
        <v-radio-group :value="defaultAddress._id" hide-details class="ma-0 pa-0 mt-1">
          <v-radio
            @click="setDefault"
            color="#3EA56E"
            :ripple="false"
            :value="storage._id"
            class="ma-0"
          ></v-radio>
        </v-radio-group>
        <span class="user-fullname ml-2" style="word-break: break-word;">
          {{ storage.firstname || '-' }} {{ storage.lastname || '' }}
        </span>
      </div>
      <v-chip
        v-if="storage._id === defaultAddress._id"
        x-small
        color="#3EA56E"
        dark
        class="font-weight-bold flex-shrink-0 ml-2"
      >
        DEFAULT
      </v-chip>
    </div>

    <div class="address-details mb-4">
      <p class="address-text">
        {{ storage.streetAddress }},<br />
        {{ storage.locality }}, {{ storage.city }},<br />
        {{ storage.district }}, {{ storage.state }},<br />
        <strong>{{ storage.pincode }}</strong>
      </p>
    </div>

    <v-spacer></v-spacer>

    <div class="contact-info mt-auto">
      <div class="d-flex align-center mb-1">
        <v-icon size="14" color="#94a3b8" class="mr-2">mdi-phone-outline</v-icon>
        <span class="contact-text">+91 {{ storage.delphone || '-' }}</span>
      </div>
      <div class="d-flex align-center" v-if="storage.email">
        <v-icon size="14" color="#94a3b8" class="mr-2">mdi-email-outline</v-icon>
        <span class="contact-text text-truncate">{{ storage.email }}</span>
      </div>
    </div>
  </v-card>
</template>

<script>
export default {
  props: ["storage", "defaultAddress"],
  methods: {
    setDefault() {
      if (this.storage._id !== this.defaultAddress._id) {
        this.$emit("stepper", {
          ref: "DefaultAddressItem",
          address: this.storage,
        });
      }
    },
  },
};
</script>

<style scoped>
.address-item-card {
  border-radius: 12px;
  border: 1px solid #e2e8f0 !important;
  transition: all 0.3s ease;
  background-color: #ffffff;
}

.address-item-card:hover {
  border-color: #3EA56E !important;
}

.default-address {
  background-color: #f0faf4;
  border-color: #3EA56E !important;
  box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.05);
}

.user-fullname {
  font-family: "ibmsemibold", sans-serif;
  font-size: 16px;
  color: #1e293b;
}

.address-text {
  font-family: "sofialight", sans-serif;
  font-size: 14px;
  color: #475569;
  line-height: 1.6;
  margin: 0;
}

.contact-text {
  font-family: "ibmregular", sans-serif;
  font-size: 13px;
  color: #64748b;
}

.ma-0 {
  margin: 0 !important;
}
</style>